<template>
  <div id="app">
    <Navbar :fixed="!heroIsVisible" />
    <router-view :heroIsVisible.sync="heroIsVisible" />
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/global/Navbar";
import Footer from "@/components/global/Footer";

export default {
  name: "App",
  components: {
    Navbar,
    Footer
  },
  watch: {
    "$route.path"() {
      this.heroIsVisible = true;
    }
  },
  data() {
    return {
      heroIsVisible: true
    };
  }
};
</script>
